import { render, staticRenderFns } from "./seriesTable.vue?vue&type=template&id=394f104f"
import script from "./seriesTable.vue?vue&type=script&lang=js"
export * from "./seriesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports